"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_REQUEST_TIMEOUT_MS = void 0;
/**
 * The standard request timeout value (in milliseconds). We pass
 * this to `axios` when making the request to commercetools.
 */
exports.DEFAULT_REQUEST_TIMEOUT_MS = 5000;
//# sourceMappingURL=constants.js.map